/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Check_EmailInputs */

const en_password_reset_check_email = /** @type {(inputs: Password_Reset_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const es_password_reset_check_email = /** @type {(inputs: Password_Reset_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu correo`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Password_Reset_Check_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_check_email = /** @type {((inputs?: Password_Reset_Check_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Check_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_check_email(inputs)
	return en_password_reset_check_email(inputs)
});